import {  Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-license-form',
  templateUrl: './license-form.component.html',
  styleUrl: './license-form.component.css'
})
export class LicenseFormComponent {
  @Input() rentalPropertyLicense!: FormGroup
  
 
  ngOnInit() { 
      this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.valueChanges.subscribe((value) => {
        if (
          value &&
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enabled &&
          this.rentalPropertyLicense.get("reasonWhy")?.enabled
        ) {
          if (this.rentalPropertyLicense.get("taxCertificateNumber")?.value) {
            this.rentalPropertyLicense.get("taxCertificateNumber")?.setValue("");
          }
          if (this.rentalPropertyLicense.get("reasonWhy")?.value) {
            this.rentalPropertyLicense.get("reasonWhy")?.setValue("");
          }
          this.rentalPropertyLicense.get("taxCertificateNumber")?.disable();
          this.rentalPropertyLicense.get("reasonWhy")?.disable();
        } else if (!value && this.rentalPropertyLicense.get("taxCertificateNumber")?.disabled) {
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enable();
        }
      });
      this.rentalPropertyLicense.get("reasonWhy")?.valueChanges.subscribe((value) => {
        if (
          value &&
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enabled &&
          this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enabled
        ) {
          this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disable();
          this.rentalPropertyLicense.get("taxCertificateNumber")?.disable();
        } else if (
          !value &&
          (this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disabled ||
            this.rentalPropertyLicense.get("taxCertificateNumber")?.disabled) &&
          this.rentalPropertyLicense.get("reasonWhy")?.enabled
        ) {
          this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enable();
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enable();
        }
      });
      this.rentalPropertyLicense.get("taxCertificateNumber")?.valueChanges.subscribe((value) => {
        this.rentalPropertyLicense.get("taxCertificateNumber")?.markAsTouched();
        value = value.replace(/[^0-9\-]/g, "");

        if (
          value &&
          (this.rentalPropertyLicense.get("reasonWhy")?.enabled ||
            this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enabled)
        ) {
          this.rentalPropertyLicense.get("reasonWhy")?.disable();
          this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disable();
          this.rentalPropertyLicense.get("reasonWhy")?.setValue("");
        } else if (
          !value &&
          (this.rentalPropertyLicense.get("reasonWhy")?.disabled ||
            this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disabled) &&
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enabled
        ) {
          this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enable();
          this.rentalPropertyLicense.get("reasonWhy")?.enable();
        }
      });
   }
   
 
 
  
 }
 